<template>
  <div
    v-if="visible"
    class="fixed bottom-0 left-0 right-0 z-[2000] flex items-center justify-between gap-[16px] border-t border-osn-grey-03 bg-osn-white-00 p-[16px] mobile:flex-col mobile:items-start"
  >
    <p class="text-[14px] text-osn-dark-grey-00">{{ $t('consent.message') }}</p>
    <div class="flex shrink-0 gap-[8px]">
      <button
        type="button"
        class="rounded-full border border-osn-grey-03 px-[16px] py-[8px] text-[14px] text-osn-dark-grey-00"
        @click="decline"
      >
        {{ $t('consent.decline') }}
      </button>
      <button
        type="button"
        class="rounded-full bg-osn-yellow-00 px-[16px] py-[8px] text-[14px] font-bold text-osn-dark-grey-00"
        @click="accept"
      >
        {{ $t('consent.accept') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useConsent } from '@/composables/useConsent'

const { grantConsent, denyConsent, hasRespondedToConsent, shouldShowConsentBanner } = useConsent()

const visible = ref(false)

// 只在 client 端判斷是否顯示;同意狀態存在 cookie,SSR 階段判斷沒有意義,
// 且會讓首屏 HTML 依環境而不同,直接放 onMounted 避免 hydration mismatch。
// consentModeEnabled 暗旗標關閉時(預設值)橫幅永遠不顯示,見 nuxt.config.ts。
onMounted(() => {
  const consentModeEnabled = useRuntimeConfig().public.consentModeEnabled
  visible.value = shouldShowConsentBanner(consentModeEnabled, hasRespondedToConsent())
})

function accept() {
  grantConsent()
  // BI P2 follow-up:補推之前被 updateAnalyticsUserId() 擋下的 set_user_id
  // (旗標開啟時,同意前只暫存 id、不推事件)。
  useUserStore().flushAnalyticsUserId()
  visible.value = false
}

function decline() {
  denyConsent()
  visible.value = false
}
</script>
